import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedLockIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.0938 3.11615C12.3036 2.86122 13.5647 3.02878 14.666 3.59076C15.7673 4.15283 16.643 5.0757 17.1465 6.20502C17.3151 6.58334 17.6142 7.48402 17.6143 8.38471V10.3447C17.9906 10.4778 18.3373 10.6918 18.625 10.9794C19.1318 11.4863 19.417 12.1737 19.417 12.8906V18.2968C19.417 19.0136 19.1318 19.701 18.625 20.2079C18.1181 20.7148 17.4307 20.9999 16.7139 20.9999H7.70312C6.98621 20.9999 6.29893 20.7149 5.79199 20.2079C5.28509 19.701 5 19.0137 5 18.2968V12.8906C5.00002 12.1737 5.28507 11.4864 5.79199 10.9794C6.07942 10.692 6.42577 10.4788 6.80176 10.3456V8.38568C6.80653 7.14909 7.23572 5.95098 8.0166 4.99213C8.79747 4.03338 9.88383 3.3712 11.0938 3.11615ZM7.70312 11.9892C7.46417 11.9892 7.23538 12.0849 7.06641 12.2538C6.89745 12.4228 6.80178 12.6516 6.80176 12.8906V18.2968C6.80176 18.5358 6.89743 18.7655 7.06641 18.9345C7.23534 19.1032 7.46436 19.1982 7.70312 19.1982H16.7139C16.9526 19.1981 17.1817 19.1032 17.3506 18.9345C17.5196 18.7655 17.6143 18.5358 17.6143 18.2968V12.8906C17.6142 12.6517 17.5195 12.4228 17.3506 12.2538C17.1817 12.0849 16.9527 11.9893 16.7139 11.9892H7.70312ZM12.208 4.78119C11.2523 4.78131 10.336 5.1611 9.66016 5.83685C8.98424 6.51277 8.60449 7.4298 8.60449 8.38568V10.1874H15.8125V8.38471C15.8124 6.5829 14.798 5.89912 14.7314 5.82611C14.5554 5.67132 13.895 4.78119 12.208 4.78119Z",
			fill: "#9F9F9F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.2998,
			cy: 14.5,
			r: .5,
			fill: "#9F9F9F",
			stroke: "#9F9F9F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2998 14.5V17",
			stroke: "#9F9F9F",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedLockIcon);
const Memo = memo(ForwardRef);
export default Memo;
